import { Component, Input, Output, EventEmitter } from '@angular/core';

import { GridItem, GridOption } from '../../grid-control.model';

@Component({
  selector: 'sd-grid-mobile-item-view',
  templateUrl: './grid-mobile-item-view.component.html',
  styleUrls: ['./grid-mobile-item-view.component.scss']
})
export class GridMobileItemViewComponent {
  @Input() gridOption: GridOption;
  @Input() item: GridItem;
  @Output() check = new EventEmitter<GridItem>();
  constructor(
  ) { }

  onCheck = (item: GridItem) => {
    this.check.emit(item);
  }
}
